<template>
  <div>
    <app-header />
    <main class="page-container">
      <card-grid />
      <google-ad />
    </main>
    <!--<app-footer />-->
  </div>
</template>

<script>
import AppHeader from "../../components/AppHeader.vue";
/* import AppFooter from "../../components/AppFooter.vue"; */
import CardGrid from "../../components/CardGrid.vue";
import firebase from "firebase";
import GoogleAd from "../../components/GoogleAdSense";

export default {
  name: "HomePage",
  components: {
    AppHeader,
    /* AppFooter, */
    CardGrid,
    GoogleAd
  },
  mounted() {
    firebase
      .database()
      .ref()
      .child("visitor")
      .once("value", sn => {
        firebase
          .database()
          .ref()
          .child("visitor")
          .update({
            value: sn.val().value + 1
          });
      });
  }
};
</script>
